export default "__VITE_PUBLIC_ASSET__057ed0b0__"